export default "__VITE_ASSET__CcsCAhoi__"